/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import * as Examples from './Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    code: "code",
    p: "p"
  }, _provideComponents(), props.components);
  if (!Examples) _missingMdxReference("Examples", false);
  if (!Examples.AdvancedSizeExample) _missingMdxReference("Examples.AdvancedSizeExample", true);
  if (!Examples.BasicSizeExample) _missingMdxReference("Examples.BasicSizeExample", true);
  if (!Examples.Default) _missingMdxReference("Examples.Default", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demo"
    }), "\n", _jsx(Examples.Default, {}), "\n", _jsxs(_components.h3, {
      children: ["Basic ", _jsx(_components.code, {
        children: "size"
      }), " usage"]
    }), "\n", _jsxs(_components.p, {
      children: ["With the default ", _jsx(_components.code, {
        children: "sizeCount"
      }), " of 12 parts."]
    }), "\n", _jsx(Examples.BasicSizeExample, {}), "\n", _jsxs(_components.h2, {
      children: ["Advanced ", _jsx(_components.code, {
        children: "size"
      }), " usage"]
    }), "\n", _jsxs(_components.p, {
      children: ["The following example has a customized amount of 4 parts (", _jsx(_components.code, {
        children: "sizeCount"
      }), ") as well as custom breakpoints and media queries."]
    }), "\n", _jsx(Examples.AdvancedSizeExample, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
